import { useQuery } from "@tanstack/react-query";

import { axiosInstanceOrion } from "@/service/Axios";
import { VITE_TENANT_ORION } from "@/constants";

import { DomainDomainValueT, DomainValues } from "./domainValue.type";

export async function getDomainValue(domainValue: DomainValues, idCommune?: number) {
  let uri = `/v1/ddv/domainValues/byDomainCode/${domainValue}`;

  if (idCommune) uri += `/byParentValueId/${idCommune}`;
  const TENANT = VITE_TENANT_ORION;

  const response = await axiosInstanceOrion.get<DomainDomainValueT[]>(uri, {
    headers: {
      "X-Tenant": TENANT,
    },
  });

  return response.data;
}

export const domainValueQueryKeys = {
  all: ["domainValues"],
  communes: () => [...domainValueQueryKeys.all, "commune"],
  neighborhood: (idCommune?: number) => [
    ...domainValueQueryKeys.all,
    "neighborhood",
    { idCommune },
  ],
  precedence: () => [...domainValueQueryKeys.all, "precedence"],
  streets: () => [...domainValueQueryKeys.all, "streets"],
  typeFront: () => [...domainValueQueryKeys.all, "typeFront"],
  typeRecollection: () => [...domainValueQueryKeys.all, "typeRecollection"],
};

export type domainValueQueryKeyType = string[] | number[] | (string | { idCommune?: number })[];

export function useGetDomainValue(
  queryKey: domainValueQueryKeyType,
  domainValue: DomainValues,
  idCommune?: number,
) {
  return useQuery({
    queryFn: () => getDomainValue(domainValue, idCommune),
    queryKey: [...queryKey, domainValue, idCommune],
    enabled: !!domainValue,
  });
}
